import React, { ForwardedRef } from 'react';

export const GridLayoutSection = React.forwardRef(
  (
    { style, className, onMouseDown, onMouseUp, onTouchEnd, children, title, key, ...props }: any,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const customFontColor = props.gridItem?.style?.color;
    return (
      <div
        ref={ref}
        key={key}
        style={style}
        className={className + ` font-sans flex items-center text-lg font-semibold text-default-text-medium`}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <div className="pl-[15px]" style={{ color: customFontColor }}>
          {title}
        </div>
        {children.at(-1)}
      </div>
    );
  },
);
